import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-number-input/basic-input';
import metadata from '../lib/libphonenumber-metadata.json';

export default function PhoneNumberInput({ value, onChange, disabled }) {
  const [v, setV] = useState(value);
  useEffect(() => {
    setV(value);
  }, [value]);
  return (
    <PhoneInput
      className="form-control"
      metadata={metadata}
      country="CA"
      value={v}
      disabled={disabled}
      onChange={(newValue) => {
        setV(newValue);
        onChange(newValue);
      }}
    />
  );
}

PhoneNumberInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

PhoneNumberInput.defaultProps = {
  value: '',
  onChange: () => null,
  disabled: false,
};
